/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
var height;
if($('.collection__header-info__text').height() > 185){
  height = $('.collection__header-info__text').height();
  $('.collection__header-info__text').height( 185 ).css({
    overflow: "hidden"
  });
  $( '<span class="show-more c-btn c-btn--light">Les mer</span>' ).insertAfter( ".collection__header-info__text" );
}

$("body").on("click", "span.show-more", function(){
    $('.collection__header-info__text').animate({'height': height}, 500);
  $(this).html('Les mindre');
  $(this).toggleClass("show-more");
  $(this).toggleClass("show-less");
});

$("body").on("click", "span.show-less", function(){
    $('.collection__header-info__text').animate({'height': '185px'}, 500);
  $(this).html('Les mer');
  $(this).toggleClass("show-more");
  $(this).toggleClass("show-less");
});
var unique_filters = [];
$('.collection-sidebar__filter-form label').each(function( index ) {
  if(unique_filters.includes($.trim($( this ).text()))){
    $(this).hide();
  }else{
  	unique_filters.push($.trim($( this ).text()));
  }
});
$('.collection-sidebar__filter-form label').click(function(e) {
  e.preventDefault();
  var txt = $( this ).text();
  
  var val = $('#'+$(this).attr('for')).is(':checked');
    $('.collection-sidebar__filter-form label').each(function( index ) {
      if($( this ).text() == txt){
        $('#'+$(this).attr('for')).prop('checked', !val);
      }
    });
   $('.collection-sidebar__filter-form').submit();
  //}
  // $(this).unbind('click').click();
});


$('.des-tablinks:first-child').click();
$('.des-tablinks:first-child').addClass('active');


function openDesTab(evt, TabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("des-tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("des-tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(TabName).style.display = "block";
  evt.className += " active";
}

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}
$(document).ready(function() {
  if ($('.cookie-announcement').length) {
    if (localStorage.getItem('barDismissed')) {
      $(".cookie-announcement").remove();
    } else {
      $(".cookie-announcement").css('display','block');
      $('.close-c-bar').click(function() {
        $(".cookie-announcement").remove();
        localStorage.setItem('barDismissed', true);
      });  
    }
  }  
});
$(".list-searched").hide();
$('#quickSearch').on('input',function(e){
  if($(this).val().length < 1){
    $(".list-searched").hide();
    return;
  }
  fetch(window.Shopify.routes.root + "search/suggest.json?q="+$(this).val()+"&resources[type]=collection,product")
  .then((response) => response.json())
  .then((suggestions) => {
    const productSuggestions = suggestions.resources.results.products;
    const collectionSuggestions = suggestions.resources.results.collections;

    if (productSuggestions.length > 0) {
      $('.products-title').show();
      $('.searched-products').show();
      $('.searched-products').html('');
      for (let i = 0; i < productSuggestions.length && i < 3; i++) {
        console.log(productSuggestions[i]);
        $('.searched-products').append('<a href="'+productSuggestions[i].url+'" class="product-search-ribbon"><div class="search-p-img"><img src="'+productSuggestions[i].image+'"></div><div class="search-p-dtl"><div class="title">'+productSuggestions[i].title+'</div><div class="vendor">'+productSuggestions[i].vendor+'</div><div class="price">'+Shopify.formatMoney(productSuggestions[i].price,"{{amount}} KR")+'</div></div></a>');
      }
    }else{
      $('.products-title').hide();
      $('.searched-products').hide();
    }
    

    if (collectionSuggestions.length > 0) {
      $('.categories-title').show();
      $('.searched-categories').show();
      $('.searched-categories').html('');
      for (let i = 0; i < collectionSuggestions.length && i < 3; i++) {
        $('.searched-categories').append('<a href="'+collectionSuggestions[i].url+'">'+collectionSuggestions[i].title+'</a>');
      }
    }else{
      $('.categories-title').hide();
      $('.searched-categories').hide();
    }
    
    if(collectionSuggestions.length < 1 && productSuggestions.length < 1){
      $(".list-searched").hide();
    }else{
      $(".list-searched").show();
    }
  }
       );
});
$('.more-results-quick-search').click(function(){
  $('.quick-search').submit();
});
$(document).mouseup(function(e) 
                    {
  var container = $(".list-searched");

  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) 
  {
    container.hide();
  }
});
$('#add_bundle_to_cart').click(function(){
  /*const data = {
    items: [
    ]
  };
  
  $('.product-single__box__block--bundle .bundle-variant-id').each(function( index ) {
    if($( this ).val()){
      data.items.push({quantity:1,id:$( this ).val()});
    }
  });
  
  console.log(data);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json', 
    success: function (res) {
      if($('.discount-code') !== undefined){
      	window.location.replace("/discount/"+$('.discount-code').text()+"?redirect=/checkout");
      }else{
        theme.ajaxCartInit();
        ajaxCart.load();
        setTimeout(function() {
          theme.mfpOpen("cart");
        }, 100);
      }
    }
  });*/
  
  
  if($(this).data('handle')){
    jQuery.getJSON('/products/'+$(this).data('handle')+'.js', function(product) {
      for(v in product.variants){
        if(product.variants[v].options.includes("Bundle")){
          console.log(Shopify.formatMoney(product.variants[v].price,"{{amount}} KR"))
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {quantity: 1, id:product.variants[v].id},
            dataType: 'json', 
            success: function (res) {
              theme.ajaxCartInit();
              ajaxCart.load();
              setTimeout(function() {
                theme.mfpOpen("cart");
              }, 100);
            }
          });
          break;
        }
      }
    });
  }
});
// Insert any custom theme js here...